import { render } from "./purchase-report.vue?vue&type=template&id=5a5c8d68"
import script from "./purchase-report.vue?vue&type=script&lang=js"
export * from "./purchase-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__